// The site's arrow, from Phosphor Icons' Light weight: a fine, even line with rounded ends that sits
// with Playfair's hairlines. Paths from @phosphor-icons/core 2.x.
// Phosphor Icons, Copyright (c) 2020 Phosphor Icons. MIT License: https://github.com/phosphor-icons/core
type Direction = 'right' | 'left' | 'up-right';

const paths: Record<Direction, string> = {
  right: 'M220.24,132.24l-72,72a6,6,0,0,1-8.48-8.48L201.51,134H40a6,6,0,0,1,0-12H201.51L139.76,60.24a6,6,0,0,1,8.48-8.48l72,72A6,6,0,0,1,220.24,132.24Z',
  left: 'M222,128a6,6,0,0,1-6,6H54.49l61.75,61.76a6,6,0,1,1-8.48,8.48l-72-72a6,6,0,0,1,0-8.48l72-72a6,6,0,0,1,8.48,8.48L54.49,122H216A6,6,0,0,1,222,128Z',
  'up-right': 'M198,64V168a6,6,0,0,1-12,0V78.48L68.24,196.24a6,6,0,0,1-8.48-8.48L177.52,70H88a6,6,0,0,1,0-12H192A6,6,0,0,1,198,64Z',
};

export function LinkArrow({ direction = 'right', size = 16, className }: { direction?: Direction; size?: number; className?: string }) {
  return (
    <svg
      className={'link-arrow link-arrow-' + direction + (className ? ' ' + className : '')}
      viewBox="0 0 256 256"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d={paths[direction]} />
    </svg>
  );
}
